import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery, Link } from "gatsby"

import Layout from "../components/common/layout/layout"
import Navigation from "../components/common/navigation/navigation"
import SEO from "../components/common/layout/seo"

export default function Template({ data }) {
  console.log(data)

  const { md } = data // data.markdownRemark holds your post data
  const { frontmatter, html } = md
  return (
    <Layout>
      <SEO title="Terms & conditions" />
      <Navigation hide={true} data={data.background} />
      <BodyMD>
        <div className="blog-post">
          <div
            className="blog-post-content"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </BodyMD>
    </Layout>
  )
}

export const data = graphql`
  query md($path: String) {
    md: markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
    background: file(
      sourceInstanceName: { eq: "product" }
      name: { eq: "logo" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`
export const BodyMD = styled.div`
  padding: 5rem 1rem 1rem 1rem;
`
